const INPUT_CLASSNAME = 'text-sm placeholder:text-sm font-semibold placeholder:font-semibold text-grey-tx';
const SELECT_CLASSNAME = 'select !text-sm !font-semibold';
const DEFAULT_MODEL_LIST = [{ value: '', extra_value: '', title: 'Seleccioná un modelo *' }, { value: '-1', extra_value: '', title: 'OTRO' }];

const defaultChatOptions = {
    webhookUrl: process.env.REACT_APP_WEBHOOK_N8N,
    webhookConfig: {
        method: 'POST',
        headers: {}
    },
    target: '#n8n-chat',
    mode: 'window',
    chatInputKey: 'chatInput',
    chatSessionKey: 'sessionId',
    loadPreviousSession: true,
    metadata: {},
    showWelcomeScreen: false,
    defaultLanguage: 'en',
    initialMessages: [],
    i18n: {
        en: {
            title: '¡Hola! 👋',
            subtitle: "Empezá tu chat con ATM Seguros.",
            footer: '',
            getStarted: 'Nueva conversación',
            inputPlaceholder: 'Escribí tu pregunta...',
        },
    },
    enableStreaming: false,
};

export { INPUT_CLASSNAME, SELECT_CLASSNAME, DEFAULT_MODEL_LIST, defaultChatOptions };